<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <div class="content">
            <div class="container-fluid pt-5">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.gradingScaleTypes')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="gradingScaleTypes.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th>{{$t('form.setting.uniqueCode')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(gradingScaleType, index) in gradingScaleTypes" :key="index">
                                            <td>{{gradingScaleType.name}}</td>
                                            <td>{{gradingScaleType.code}}</td>

                                            <td class="text-right">
                                                <button class="btn btn-info btn-sm" @click="edit(index)">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-danger btn-sm" @click="remove(index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.gradingScaleTypeCreate')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.gradingScaleTypeEdit')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                pagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                code: '',

                gradingScaleTypes: []
            }
        },

        mounted() {
            this.getGradingScaleTypes();
        },

        methods: {

            getGradingScaleTypes() {
                this.isLoading = true;

                axios
                    .get('/api/grading-scale-types?page=' + this.pagination.current_page)
                    .then(response => {
                        this.gradingScaleTypes = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getGradingScaleTypes();
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post('/api/grading-scale-types', {
                        name: this.name
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);
                            this.gradingScaleTypes.unshift(response.data.data);
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {

                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(index) {
                this.name = this.gradingScaleTypes[index].name;
                this.id = this.gradingScaleTypes[index].id;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/grading-scale-types/${this.id}`, {
                        name: this.name
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.cancel();
                            this.getGradingScaleTypes();
                            this.showAlert(response.data.message);
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                        this.isLoading = false;
                    })
            },

            cancel() {
                this.name = '';
                this.id = null;
                this.toggleForm = true;
            },

            remove(index) {
                if (confirm(this.$t('form.validation.delete'))) {

                    this.clear();
                    this.isLoading = true;

                    axios
                        .delete(`/api/grading-scale-types/${this.gradingScaleTypes[index].id}`)
                        .then(response => {
                            if (response.data.success) {
                                this.showAlert(response.data.message);
                                this.gradingScaleTypes.splice(index, 1);
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.showAlert(error.response.data.message, 'danger');
                            }

                            this.isLoading = false;
                        })
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
